/**
 * Product Component
 * Funcionalidad de páginas de producto
 */

// Product gallery
document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach(gallery => {
    const thumbnails = gallery.querySelectorAll('[data-thumbnail]');
    const mainImage = gallery.querySelector('[data-main-image]');

    if (!mainImage) return;

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => {
        e.preventDefault();

        const imageSrc = thumbnail.dataset.imageSrc;
        const imageAlt = thumbnail.dataset.imageAlt || '';

        if (imageSrc) {
          mainImage.src = imageSrc;
          mainImage.alt = imageAlt;

          // Update active state
          thumbnails.forEach(t => t.classList.remove('ring-2', 'ring-primary'));
          thumbnail.classList.add('ring-2', 'ring-primary');
        }
      });
    });
  });
});

// Variant selector
document.addEventListener('change', (e) => {
  if (e.target.matches('[data-variant-option]')) {
    const form = e.target.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    const selectedOptions = Array.from(formData.entries())
      .filter(([key]) => key.startsWith('option'))
      .map(([, value]) => value);

    // Aquí puedes agregar lógica para:
    // - Actualizar precio
    // - Actualizar disponibilidad
    // - Actualizar imagen principal
    // - Actualizar variant ID
  }
});
